import { module }from 'stereomodularjs';

const focusElsListDisabled = 'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';
const focusElsList = 'a[href], button, input, select, textarea';
const overlayPanelContainer = document.querySelector('.js-overlay-content-container');

export default class extends module {
    constructor(m) {
        super(m);

        this.firstInit = true,
        this.events = {
            click: 'overlayOpen'
        }
    }

    init() {
        let thisEl = this.el;

        // Set all focusable elements to disabled state
        let focusElsDisabled = overlayPanelContainer.querySelectorAll(focusElsListDisabled);
        focusElsDisabled.forEach(focusEl => {
            focusEl.setAttribute('disabled', true);
        });
    }

    overlayOpen() {
        let thisEl = this.el;

        // Reset class for accessibility focus back
        if (document.querySelector('.js-overlay-focus-back')) {
            classRemove(document.querySelector('.js-overlay-focus-back'),'js-overlay-focus-back');
        }

        // Set class for accessibility focus back
        classAdd(thisEl,'js-overlay-focus-back');

        // Add class to HTML enabling Overlay
        classAdd(document.querySelector('html'),'is-overlay-active');

        // Scope overlay class
        let overlayPanel = document.querySelector(thisEl.getAttribute('data-overlay'));

        // Set current overlay content active
        overlayPanel.classList.add('is-active');

        // Set proper states to container
        overlayPanelContainer.setAttribute('aria-hidden', 'false');
        overlayPanelContainer.setAttribute('open', '');

        // Set proper states to buttons (quick close and overlay close)
        let closeButtons = document.querySelectorAll('.js-overlay__close button');
        closeButtons.forEach(button => {
            button.setAttribute('aria-hidden', 'false');
            button.removeAttribute('disabled');
        });

        // Remove disabled state from active overlay focusable elements
        let focusElsRemoveDisabled = overlayPanel.querySelectorAll(focusElsList);
        focusElsRemoveDisabled.forEach(focusEl => {
            focusEl.removeAttribute('disabled');
        });

        // Get all focusable elements without disabled state
        let focusEls = overlayPanelContainer.querySelectorAll(focusElsListDisabled);

        // Save first focusable element from node list
        let firstFocusEl = focusEls[0];

        // Save last focusable element from node list
        let lastFocusEl = focusEls[focusEls.length - 1];

        // Listener to trap focus inside element (must make action inside container to close overlay)
        overlayPanelContainer.addEventListener('keydown', function (e) {
            if (e.key === 'Tab' || e.keyCode === 9) {
                if (e.shiftKey) /* shift + tab */ {
                    if (document.activeElement === firstFocusEl) {
                        lastFocusEl.focus();
                        e.preventDefault();
                    }
                } else /* tab */ {
                    if (document.activeElement === lastFocusEl) {
                        firstFocusEl.focus();
                        e.preventDefault();
                    }
                }
            }
        });

        // If content is video append it to video container
        if (thisEl.getAttribute('data-video')) {
            let overlayVideo = thisEl.getAttribute('data-video');
            document.querySelector('.js-overlay-video').innerHTML = overlayVideo;
        }

        // Set focus on quick close
        setTimeout(() => {
            document.activeElement.blur();
            document.querySelector('.js-accessibility-close button').focus();
        }, 601);
    }
}
/*
    Support multiple overlays

    USAGE: TRIGGERS

    For video embed:
    <button class="o-button" data-module="Overlay" data-overlay=".js-overlay-content-1" data-video='<iframe width="560" height="315" src="https://www.youtube.com/embed/Z6IgWL7nKi4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' aria-label="Afficher la vidéo en superposition">Afficher la vidéo</button>

    For text :
    <button class="o-button" data-module="Overlay" data-overlay=".js-overlay-content-3" aria-label="Afficher le formulaire d'infolettre">Afficher le formulaire d'infolettre</button>

    USAGE: HTML MARKUP

    <dialog class="c-overlay-wrap js-overlay-content-container" aria-hidden="true">
        <div class="c-overlay-content js-overlay-content">
            <div class="js-overlay__close js-accessibility-close c-overlay-accessibility__close" data-module="OverlayClose">
                <button aria-hidden="true">Fermer l'affichage superposé</button>
            </div>

            <div class="c-overlay-content__item js-overlay-content-1 -video" data-overlay="content">
                <div class="c-overlay-video__wrap">
                    <div class="c-overlay-video js-overlay-video"></div>
                </div>
            </div>

            <div class="c-overlay-content__item js-overlay-content-2 -small" data-overlay="content">
                <div class="o-text">
                    <h1>Titre</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit...</p>
                    <a href="#" class="o-button">Lien</a>
                    <a href="#" class="o-button">Autre Lien</a>
                </div>
            </div>

            <div class="c-overlay-content__item js-overlay-content-3" data-overlay="content">
                <div class="o-text">
                    <h3>Newsletter</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit...</p>
                    <form action="#">
                        <input type="email" name="email" placeholder="Email">
                        <button>Soumettre</button>
                    </form>
                </div>
            </div>
        </div>

        <div class="c-overlay__bg js-overlay__close" data-module="OverlayClose">
            <button class="c-overlay__close" aria-label="Fermer le message superposé" aria-hidden="true">
                <?php svg('close'); ?>
            </button>
        </div>
</dialog>

*/